import { useMutation } from 'react-query'
import postRegisterService from '../services/postRegisterService'

function usePostRegisterPatient() {

  return useMutation((value:object)=>postRegisterService(value) );
}

export default usePostRegisterPatient
